import { useState } from 'react';
import '../assets/styles/Contact.css';

// const BACKEND_BASE_URI = process.env.REACT_APP_BACKEND_BASE_URI;
const GSCRIPT_URL = 'https://script.google.com/macros/s/AKfycbxTHsa3eaaxJZfaYd2OsQrcnINp5tqEnzQVgtNv9NrwL4y6G1mlVjB2UT00BKCbc0j4/exec';

export default function Contact() {
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [feedback, setFeedback] = useState({ type: "", message: "" });
  const [formTransform, setFormTransform] = useState('');
  const [formShadow, setFormShadow] = useState('');

  async function saveLeadToSheet() {
    if (!GSCRIPT_URL) throw new Error("Sheets endpoint not configured");
    const fd = new FormData();
    // primary fields
    fd.append("email", email);
    fd.append("subject", subject);
    fd.append("message", message);
  
    const res = await fetch(GSCRIPT_URL, { method: "POST", body: fd });
    if (!res.ok) throw new Error(`Sheet log failed (HTTP ${res.status})`);
    // Apps Script often returns HTML; don’t assume JSON. If you return JSON, you can parse here.
    return true;
  }

  // 2) Send email via your backend
  async function sendEmail() {
    const res = await fetch(`https://startup-website-x1s7.onrender.com/api/v1/send-email`, {
    // const res = await fetch(`http://localhost:5000/api/v1/send-email`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, subject, message }),
    });
    if (!res.ok) throw new Error("Failed to send email. Please try again.");
    return true;
  }

  async function handleSubmit(e) {
    e.preventDefault();

    if (!email || !subject || !message) {
      setFeedback({ type: "error", message: "All fields are required!" });
      return;
    }

    setLoading(true);
    setFeedback({ type: "", message: "" });

    try {
      // Save to sheet first
      try {
        await saveLeadToSheet();
      } catch (sheetErr) {
        // Decide policy: proceed or block. Here we proceed but show a warning.
        console.warn("Sheet logging failed:", sheetErr);
        setFeedback({ type: "error", message: `Logged a warning: ${sheetErr?.message || sheetErr}` });
      }

      // Then trigger email
      await sendEmail();

      setFeedback({ type: "success", message: "📧 Email sent and lead logged (or attempted)!" });
      setEmail("");
      setSubject("");
      setMessage("");
    } catch (error) {
      setFeedback({ type: "error", message: error.message || "Something went wrong." });
      // Below this should be removed....
      setEmail("");
      setSubject("");
      setMessage("");
    } finally {
      setLoading(false);
    }
  }

  return (
    <section aria-labelledby="contact-heading" className="bg-sky-50">
      <div className="max-w-6xl mx-auto px-6 py-20">
        <div className="text-center mb-12 contact-marin">
          <h2 id="contact-heading" className="text-4xl md:text-5xl font-extrabold text-sky-950 inline-flex items-center gap-3">
            <span className="inline-block transform-gpu animate-bounce-slow" style={{ willChange: 'transform' }}>📩</span>
            Get in Touch
          </h2>
          <p className="mt-3 text-sky-900 max-w-2xl mx-auto">We explore and deliver the best — tell us about your idea and we'll follow up.</p>
        </div>

        {feedback.message && (
          <div
            role="status"
            className={`mx-auto max-w-3xl mb-8 p-4 rounded-md text-center font-semibold ${feedback.type === "success" ? "bg-green-50 text-green-800 border border-green-200 animate-fade-in" : "bg-red-50 text-red-800 border border-red-200 animate-fade-in"}`}
          >
            {feedback.message}
          </div>
        )}

        <div className="max-w-5xl mx-auto">
          {/* Right card: form (now centered) */}
          <div
            className="bg-white/90 backdrop-blur-sm rounded-xl shadow-xl border border-sky-100 p-6 md:p-8 transition-transform duration-200"
            onMouseMove={(e) => {
              const rect = e.currentTarget.getBoundingClientRect();
              const x = e.clientX - rect.left;
              const y = e.clientY - rect.top;
              const px = (x / rect.width) - 0.5; // -0.5 -> 0.5
              const py = (y / rect.height) - 0.5;
              const rotateY = px * 10; // max 10deg
              const rotateX = -py * 8; // max 8deg
              const scale = 1.02;
              setFormTransform(`perspective(900px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(${scale})`);
              const shadowX = -rotateY * 1.5;
              const shadowY = Math.abs(rotateX) * 1.2;
              setFormShadow(`${shadowX}px ${shadowY}px 40px rgba(2,6,23,0.08)`);
            }}
            onMouseLeave={() => {
              setFormTransform('');
              setFormShadow('');
            }}
            style={{ transform: formTransform, boxShadow: formShadow }}
          >
            <form onSubmit={handleSubmit} className="space-y-5">
              <div className="grid grid-cols-1 gap-4">
                <div>
                  <label htmlFor="email-id" className="block text-sm font-medium text-sky-700 mb-2">Email</label>
                  <input
                    id="email-id"
                    type="email"
                    placeholder="you@company.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    className="w-full px-4 py-3 bg-white border border-sky-200 rounded-lg text-sky-800 focus:outline-none focus:ring-2 focus:ring-sky-300 transition-shadow duration-150 shadow-sm"
                    aria-label="Your email"
                  />
                </div>

                <div>
                  <label htmlFor="subject-id" className="block text-sm font-medium text-sky-700 mb-2">Subject</label>
                  <input
                    id="subject-id"
                    type="text"
                    placeholder="Brief subject or project title"
                    value={subject}
                    onChange={(e) => setSubject(e.target.value)}
                    required
                    className="w-full px-4 py-3 bg-white border border-sky-200 rounded-lg text-sky-800 focus:outline-none focus:ring-2 focus:ring-sky-300 transition-shadow duration-150 shadow-sm"
                    aria-label="Subject"
                  />
                </div>

                <div>
                  <label htmlFor="message-id" className="block text-sm font-medium text-sky-700 mb-2">Message</label>
                  <textarea
                    id="message-id"
                    placeholder="Tell us a little about your idea, timeline, and budget (optional)"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    required
                    rows={6}
                    className="w-full px-4 py-3 bg-white border border-sky-200 rounded-lg text-sky-800 focus:outline-none focus:ring-2 focus:ring-sky-300 transition-shadow duration-150 shadow-sm resize-none"
                    aria-label="Message"
                  />
                </div>
              </div>

              <div>
                <button
                  type="submit"
                  disabled={loading}
                  className="w-full inline-flex items-center justify-center gap-3 py-3 px-4 bg-gradient-to-r from-sky-600 to-sky-500 text-white font-semibold rounded-lg hover:from-sky-500 hover:to-sky-400 disabled:opacity-60 transition-transform transform hover:-translate-y-0.5"
                >
                  <svg className={`w-5 h-5 ${loading ? 'animate-spin' : ''}`} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
                    <path d="M2 12h20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M16 6l6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  {loading ? 'Sending...' : 'Send message'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};